import { ref } from 'vue';

export default () => {
    const show = ref(false);
    const row = ref({});

    function open(r) {
        row.value = r || {};
        show.value = true;
    }

    function close() {
        show.value = false;
        row.value = {};
    }

    return { show, open, close, row }
}